
export class VisitasVariedadMesModel {
    [key: string]: string | number;
    id?: string; 
    cultivo = '';
    cultivo_legacy?: string;
    variedad = '';
    variedad_legacy?: string;
    id_variedad = '';
    enero?: number;
    febrero?: number;
    marzo?: number;
    abril?: number;
    mayo?: number;
    junio?: number;
    julio?: number;
    agosto?: number;
    septiembre?: number;
    octubre?: number;
    noviembre?: number;
    diciembre?: number;
    unidades?: string;
    id_parcela?: string;
    codigo_cultivo?: string;
    codigo_variedad?: string;
    codigo?: string;
    id_cultivo?: string;
}